<template>
  <div class="card" :class="{ draggable: draggable }" :draggable="draggable" ref="card" :data-index="index">
    <div class="header" v-if="$slots.title || $slots.subtitle">
      <div class="left">
        <div class="title">
          <slot name="title"></slot>
        </div>
        <div class="subtitle">
          <slot name="subtitle"></slot>
        </div>
      </div>
      <div class="right">
        <slot name="actions"></slot>
      </div>
    </div>

    <div class="content" v-if="$slots.content">
      <slot name="content"></slot>

      <div class="action" v-if="$slots.bottom">
        <slot name="bottom"></slot>
      </div>
    </div>

  </div>
</template>
<script>
import { Card } from "@eds/vanilla";

export default {
  props: {
    draggable: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      required: true
    }
  },
  mounted() {
    const card = new Card(this.$refs.card);
    card.init();
  }
};
</script>
<style lang="less" scoped>
@import '~@/assets/common.less';

.card .eds-form {
    padding: 0;
}
</style>